import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { isSessionActive, redirectToSSO } from "./AuthenticatedUser";
// import Page from "../../pages/Page";
import PageV2 from "../../pages/v2/Page"
import { AppState } from "../../contexts/Core";
import {Spinner} from "@livingdesign/react";

export default function AuthenticatedRoute({
  component: Component,
  componentProps,
  pageProps,
  ...routeProps
}) {
  const authenticated = isSessionActive();
  return (
    <AppState>
      {({ authError, setAuthError, appError, setPageTitle }) => {
        return (
          <Route
            {...routeProps}
            render={(props) =>
              authenticated === true ? (
                <PageV2
                  {...pageProps}
                  error={authError ? authError : appError ? appError : null}
                  clearError={() => setAuthError()}
                  setPageTitle={setPageTitle}
                >
                  <Suspense
                    fallback={
                      <div style={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Spinner size="large" />
                      </div>
                    }
                  >
                    <Component {...props} {...componentProps} />
                  </Suspense>
                </PageV2>
              ) : (
                redirectToSSO(true, window.location.pathname)
              )
            }
          />
        );
      }}
    </AppState>
  );
}
